import { Collapse, Fade, Grow, Slide, Tab, Tabs } from '@material-ui/core';
import * as React from 'react';
import { useEffect } from 'react';
import { useContext } from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { SettingsContext } from '../../Context';
import { ProgramModel } from '../../Models/Program.interface';
import { VideoShelf } from '../VideoShelf/VideoShelf';
import { AllEpisodes } from './AllEpisodes';

import "./css.css";
 const Container = styled.div`
display: flex;
align-items: row;
justify-content: space-between;
    @media (min-width: 990px ){
        margin-left: 80px;
        margin-right: 80px;
    }

    @media(max-width: 767px){
        margin-right: 40px;
        margin-left: 40px;
    }

    @media(max-width: 480px){
        margin-right: 20px;
        margin-left: 20px;
    }
`

const TabPanel = styled.div<{value: any, index: number}>`
    display: flex;
    align-items: row;
    justify-content: space-between;
    flex-wrap: wrap;
    max-width: calc(100vw - 160px);
    @media (min-width: 990px ){
        margin-left: 80px;
        margin-right: 80px;
    }

    @media(max-width: 767px){
        margin-right: 40px;
        margin-left: 40px;
    }

    @media(max-width: 480px){
        margin-right: 20px;
        margin-left: 20px;
    }
`

const Title = styled.h3`
    font-size: 1.3em;
    color: rgba(150, 150, 150, 1);
    font-weight: bold;
    margin-bottom: 0.5em;
`

const Desc = styled.p`
    margin-top: 0;
    margin-bottom: 2em;
    color: white;
    max-width: 600px;
    font-size: 1.2em;
    font-weight: normal;
    line-height: 1.5em;

`



type ProgramTabProps = {
    program: ProgramModel,
    mini?: boolean
}


export const ProgramTabs = (props: ProgramTabProps) => {
    const [ value, setValue] = useState<number>()
    const { mini, program } = props
    const onTabChange = (e, v) => {
        setValue(v)
    }

    useEffect(() => {
        setTimeout(() => {
            setValue(0)
        }, 1000)
    }, [])

    const a11yProps = (index: any) => {
        return {
          id: `program-tab-${index}`,
          'aria-controls': `program-tabpanel-${index}`,
        };
      }
    
    const { locale } = useContext(SettingsContext)



    return(
        <>
        <Container>
            <Tabs 
                value={value} 
                onChange={onTabChange} 
                aria-label="program tabs"
                indicatorColor="secondary"
                style={{borderBottom: '1px solid grey', width: '100%'}}
            >
                <Tab 
                    label={locale?.allEpisodes} 
                    {...a11yProps(0)} 
                    style={{
                        color: value === 0 ? "white" : "rgba(200, 200, 200, 1)",
                        fontWeight: value === 0 ? "bold" : "normal"
                    }} />
                {mini && <Tab
                    label={locale?.miniSeries}
                    {...a11yProps(1)}
                    style={{
                        color: value === 1 ? "white" : "rgba(200, 200, 200, 1)",
                        fontWeight: value === 1 ? "bold" : "normal"
                    }} />}
                <Tab 
                    label={locale?.details} 
                    {...a11yProps( mini ? 2 : 1)} 
                    style={{
                        color: value === (mini ? 2 : 1) ? "white" : "rgba(200, 200, 200, 1)",
                        fontWeight: value === (mini ? 2 : 1) ? "bold" : "normal"
                    }} />
            </Tabs>
    </Container>
    <TabPanel value={value} index={0}>
        <Collapse in={value === 0} style={{flex: 1}}>
            <AllEpisodes program={program}/>
        </Collapse>
    </TabPanel>
    {!!mini && <TabPanel value={value} index={1}>
        <Collapse in={value === 1}>
              {/* <VideoShelf path="/related/500" title="500"   />    */}
        </Collapse>
    </TabPanel>}
    <TabPanel value={value} index={mini ? 2 : 1}>
        
        <Collapse in={value === (mini ? 2 : 1 )}>
            <Title>{program?.name}</Title>
            <Desc>{program?.description}</Desc>
        </Collapse>
        
    </TabPanel>
    </>
)
}

